export default "__VITE_ASSET__Ct8pg0re__"